import { render, staticRenderFns } from "./LoginMarketing.vue?vue&type=template&id=3c48f2cf&"
import script from "./LoginMarketing.vue?vue&type=script&lang=ts&"
export * from "./LoginMarketing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports